const getters = {
    token: (state: any) => state.user.token,
    name: (state: any) => state.user.name,
    realname: (state: any) => state.user.realname,
    roles: (state: any) => state.user.roles,
    userId: (state: any) => state.user.userId,
    salesman: (state: any) => state.user.salesman,
    wx: (state: any) => state.user.wx,
    purchase: (state: any) => state.user.purchase,
    userBrands: (state: any) => state.user.userBrands,
    allProvince: (state: any) => state.user.province
}
export default getters